export default __webpack_public_path__ + "static/predefined-service-blocking-829d4e52c079cebfb0fb73ca8ffeacdb.png";